export const PERFORMANCE_SET_IS_LOW_PERFORMANCE =
	'PERFORMANCE_SET_IS_LOW_PERFORMANCE';
